export const SET_FIXED_LINE_HOT_OFFERS = 'SET_FIXED_LINE_HOT_OFFERS'
export const FAILED_SET_FIXED_LINE__HOT_OFFERS =
  'FAILED_SET_FIXED_LINE__HOT_OFFERS'
export const SET_ALL_OFFERS = 'SET_ALL_OFFERS'
